/**
 * HTML de matérias do periódico — Admin (diagramação) e Portal (Revista).
 * Passe sempre `apiBase` = `urlApi` do `@/config/global` do projeto.
 */

export const SOLLICITA_MATERIA_API_PH = '__SOLLICITA_MATERIA_API__'

export function trimApiBase(apiBase) {
    const a = apiBase != null && String(apiBase).trim() !== '' ? String(apiBase).trim() : ''
    const e = process.env.VUE_APP_URL_API
    const env = e != null && String(e).trim() !== '' ? String(e).trim() : ''
    const raw = a || env
    return raw.replace(/\/$/, '')
}

export function sanitizeHtmlMateriaConteudo(html) {
    if (html == null || html === '') return ''
    let cleanHtml = String(html)

    cleanHtml = cleanHtml.replace(/\s*onmouseover\s*=\s*"[^"]*msoCommentShow[^"]*"/gi, '')
    cleanHtml = cleanHtml.replace(/\s*onmouseout\s*=\s*"[^"]*msoCommentHide[^"]*"/gi, '')
    cleanHtml = cleanHtml.replace(/\s*onmouseover\s*=\s*'[^']*msoCommentShow[^']*'/gi, '')
    cleanHtml = cleanHtml.replace(/\s*onmouseout\s*=\s*'[^']*msoCommentHide[^']*'/gi, '')

    cleanHtml = cleanHtml.replace(/<a[^>]*href=["']?#_msocom_[^"']*["'][^>]*>/gi, '<a>')
    cleanHtml = cleanHtml.replace(/<a[^>]*name=["']?_msocom_[^"']*["'][^>]*>/gi, '<a>')

    return cleanHtml
}

export function normalizarGetUrlS3ParaPlaceholderMateria(html, apiBase) {
    if (html == null || html === '') return ''
    const ph = SOLLICITA_MATERIA_API_PH
    let s = String(html)
    const base = trimApiBase(apiBase)
    if (base) {
        const esc = base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        s = s.replace(new RegExp(esc + '(\\/Utilidade\\/GetUrlS3\\?)', 'gi'), `${ph}$1`)
    }
    s = s.replace(/https?:\/\/[^"'>\s]+\/Utilidade\/GetUrlS3\?/gi, `${ph}/Utilidade/GetUrlS3?`)
    s = s.replace(/(["'])\/Utilidade\/GetUrlS3\?/gi, `$1${ph}/Utilidade/GetUrlS3?`)
    s = s.replace(/((?:src|href)\s*=\s*)(["'])(\/api\/v\d+\/Utilidade\/GetUrlS3\?)/gi, `$1$2${ph}/Utilidade/GetUrlS3?`)
    s = s.replace(/((?:src|href)\s*=\s*)(["'])(Utilidade\/GetUrlS3\?)/gi, `$1$2${ph}/$3`)
    return s.split(ph + ph).join(ph)
}

export function expandirPlaceholderApiMateria(html, apiBase) {
    const s = String(html ?? '')
    const base = trimApiBase(apiBase)
    if (!base) return s
    const ph = SOLLICITA_MATERIA_API_PH
    if (s.indexOf(ph) === -1) return s
    return s.split(ph).join(base)
}

export function sanitizeHtmlMateriaParaExibicao(html, apiBase) {
    // As imagens/links S3 já vêm assinados do servidor; aqui só resta a limpeza de HTML.
    // (parâmetro apiBase mantido por compatibilidade de assinatura)
    void apiBase
    return sanitizeHtmlMateriaConteudo(html ?? '')
}

export function sanitizeHtmlMateriaParaPersistencia(html, apiBase) {
    return normalizarGetUrlS3ParaPlaceholderMateria(sanitizeHtmlMateriaConteudo(html ?? ''), apiBase)
}
